import { connect } from 'react-redux';
import { setJourneyParams, changeJourneyParam } from '@store/yourJourney/actions';
import { yourJourneySelectors } from '@store/yourJourney/selectors';
import { AvailabilityForm } from './AvailabilityForm';

const mapStateToProps = (state) => ({
  journeyParams: yourJourneySelectors.getParsedJourneyParams(state),
});

const mapDispatchToProps = {
  setJourneyParams,
  changeJourneyParam,
};

export const AvailabilityFormContainer: any = connect(
  mapStateToProps,
  mapDispatchToProps
)(AvailabilityForm);
